import React, { useState, Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { Dialog, Transition } from '@headlessui/react'
import { formBtn1, formBtn2, inputClass, labelClass } from '../Utils/CustomClasses';
import Error from '../Error/Error';
import { AddRoleAPI, UpdateRoleAPI } from '../../API/Api';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import ButtonLoader from '../Loader/ButtonLoader';
import { IconEdit } from '@tabler/icons-react';

export default function AddRole({ edit, filterRecords, rowdata, Company }) {
  const userDetails = useSelector(state => state?.login?.userDetails)
  const { register, handleSubmit, control, watch, reset, formState: { errors }, setValue } = useForm();
  const [isOpen, setIsOpen] = useState(false)
  const [loader, setloader] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen)
    reset()
  }

  useEffect(() => {
    if (edit == true) {
      reset({
        "hierarchyLevel": rowdata?.hierarchyLevel,
        "roleName": rowdata?.roleName
      })
    }

  }, [isOpen, edit])

  useEffect(() => {
    if (userDetails?.company?.companyName) {
      setValue("company", userDetails?.company?.companyName);
    }
  }, [isOpen]);


  const onSubmit = async (data) => {
    setloader(true)
    const Payload = {
      "hierarchyLevel": data.hierarchyLevel,
      "roleName": data.roleName,
      "company": userDetails?.company?._id
    }
    try {
      let response
      if (edit == true) {
        let updatedPayload = { ...Payload };
        delete updatedPayload.company
        response = await UpdateRoleAPI(rowdata?._id, updatedPayload)
      } else {
        if (userDetails?.role?.roleName == "SuperAdmin") {
          response = await AddRoleAPI(data)
        } else {
          response = await AddRoleAPI(Payload)
        }
      }
      if (response?.status == 201) {
        toggle();
        setloader(false)
        toast.success(response?.data?.message)
        filterRecords();        
      } else {
        setloader(false)
        toast.error(response?.error)
      }
    } catch (err) {
      setloader(false)
      console.log('Error:', err)
    }
  }
  return (
    <>
      {
        edit ? <button onClick={toggle} className='py-1 rounded-lg flex justify-center w-[10%]'>
          <IconEdit stroke={1.5} size={24} color="#000" />
        </button> : <button onClick={toggle} className={formBtn1}>Add Role</button>
      }
      <Transition appear show={isOpen} as={Fragment} >
        <Dialog as='div' className='relative z-[100]' onClose={toggle}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-scroll ">
            <div className='flex items-center justify-center min-h-full p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl"
                >
                  <Dialog.Title
                    as="h2"
                    className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                  >{edit ? 'Edit Role' : 'Add Role'}</Dialog.Title>
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="p-4">
                        <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                          <div className="">
                            <label className={labelClass}>
                              Hierarchy Level<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type='number'
                              className={inputClass}
                              {...register('hierarchyLevel', { 
                                required: true,
                                pattern: {
                                  value: /^[0-9]+$/, 
                                  message: "Only whole numbers are allowed"
                               }})}
                            />
                            {errors.hierarchyLevel && <Error title='Hierarchy Level is Required*' />}
                          </div>
                          <div className="">
                            <label className={labelClass}>
                              Role Name<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type='text'
                              className={inputClass}
                              {...register('roleName', { required: true })}
                            />
                            {errors.roleName && <Error title='Role Name is Required*' />}
                          </div>
                        </div>
                        {edit == false && (<div className='grid lg:grid-cols-1 py-1 mx-4'>
                          <div className="">
                            {
                              userDetails?.role?.roleName == "Admin" ?
                                <>
                                  <label className={labelClass}>
                                    Company Name<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type='text'
                                    className={inputClass}
                                    disabled
                                    {...register('company', { required: true })}
                                  />
                                </> :
                                <>
                                  <label className={labelClass}>
                                    Company Name<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <select
                                    name="company_id"
                                    placeholder='Company Name'
                                    className={`${inputClass} !bg-slate-100`}
                                    {...register("company")}
                                  >
                                    {
                                      Company?.map((data) => (
                                        <option className="text-black" key={data?._id} value={data?._id}>{data?.companyName}</option>
                                      ))
                                    }
                                  </select>
                                </>
                            }
                            {errors.company && <Error title='Company ID is Required*' />}
                          </div>
                        </div>)}
                      </div>
                      <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                        {loader ? <ButtonLoader /> : <button
                          type="submit"
                          className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                        >
                          <span className="opacity-100">
                            {edit ? "Update" : "Submit"}
                          </span>
                        </button>}
                        <button
                          type="button"
                          className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                          onClick={toggle}
                        >
                          Close
                        </button>
                      </footer>
                    </form>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}